module.exports = __webpack_public_path__ + "media/images/ra-review-icon-09b5c2d365eefe49813a30db5393b2b9.svg";